import { React, useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useNavigate, Link } from "react-router-dom";

const UserNavigation = ({displayUsername}) => { 

    const { userId } = useParams(); 
    const [activeTab, setActiveTab] = useState(0);
    const location = useLocation();
    useEffect(() => {
        
        var pathname = location.pathname;
        var Query = userId;  
        if(pathname!=null && pathname!=undefined) {
             
            setActiveTab(pathname);
        }
      }, []);
    return (
      <div
        class="card"
        style={{
          marginBottom: "1px",
          marginTop: "10px",
          marginLeft: "5px",
          marginRight: "3px"
        }}
      >
        <div class="card-body">
          <style>
            {`
                <style>
              .btn-success {
                color: #fff;
                background-color: #00b181;
                border-color: #28a745;
              }

              .btn_top {
                display: inline-block;
                font-weight: 400;
                text-align: center;
                white-space: nowrap;
                vertical-align: middle;
                user-select: none;
                border: 1px solid transparent;
                padding: .375rem .75rem;
                font-size: .875rem;
                line-height: 1.5;
                border-radius: .25rem;
                transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
              }
            </style>
                `}
          </style>

          <Link
            to={`/agent/edit/${userId}`}
            className="btn btn-primary site_family"
            style={{
              color:
                activeTab === "/agent/edit/" + userId ? "#000000" : "#ffffff"
            }}
          >
            Edit User
          </Link>

          <Link
            to={`/agent/ledger/${userId}`}
            style={{
              marginLeft: "4px",
              color:
                activeTab === "/agent/ledger/" + userId ? "#000000" : "#ffffff"
            }}
            className="btn btn-primary site_family"
          >
            Ledger{" "}
          </Link>

          <Link
            to={`/agent/bets/${userId}`}
            className="btn btn-primary site_family"
            style={{
              marginLeft: "4px",
              color:
                activeTab === "/agent/bets/" + userId ? "#000000" : "#ffffff"
            }}
          >
            Bets
          </Link>

          <Link
            to={`/agent/profit-loss/${userId}`}
            className="btn btn-primary site_family"
            style={{
              marginLeft: "4px",
              color:
                activeTab === "/agent/profit-loss/" + userId
                  ? "#000000"
                  : "#ffffff"
            }}
          >
            Profit-Loss
          </Link>

          <Link
            to={`/agent/current-position/${userId}`}
            className="btn btn-primary site_family"
            style={{
              marginLeft: "4px",
              color:
                activeTab === "/agent/current-position/" + userId
                  ? "#000000"
                  : "#ffffff"
            }}
          >
            Current Position
          </Link>

          <div style={{ fontSize: "20px", textAlign: "right", float: "right" }}>
            <strong className="site_family">{displayUsername}</strong>
          </div>
        </div>
      </div>
    );

}

export default UserNavigation;